import { z } from 'zod';

import {
  GetAdminV1StoresStoreIdReportsProductsEngagementSort as EngagementSort,
  ReportInterval,
} from '@nucleus-commerce/api-client/admin';

import { DAY_KEY, RANGE_PRESETS } from './report-range';

/**
 * URL search of every reports screen. Anything malformed is dropped rather than failing the
 * route, so a hand-edited URL lands on the default range.
 */
export const reportRangeSearchSchema = z.object({
  range: z.enum(RANGE_PRESETS).optional().catch(undefined),
  from: z.string().regex(DAY_KEY).optional().catch(undefined),
  to: z.string().regex(DAY_KEY).optional().catch(undefined),
});

export type ReportRangeSearch = z.infer<typeof reportRangeSearchSchema>;

export const salesSearchSchema = z.object({
  interval: z.enum(ReportInterval).optional().catch(undefined),
});

export type SalesSearch = z.infer<typeof salesSearchSchema>;

/** The products report's own search: how the engagement table is sorted (`-views` by default). */
export const productsReportSearchSchema = z.object({
  engagementSort: z.enum(EngagementSort).optional().catch(undefined),
});

export type ProductsReportSearch = z.infer<typeof productsReportSearchSchema>;
